import React from "react";

import { Avatar } from "@mui/material";

type AvatarProps = {
  firstName: string;
  lastName: string;
  size?: "small" | "medium" | "large";
};

const AvatarInitials: React.FC<AvatarProps> = ({ firstName, lastName, size = "medium" }) => {
  const avatarSize = {
    small: { width: 32, height: 32 },
    medium: { width: 40, height: 40 },
    large: { width: 56, height: 56 },
  }[size];
  return (
    <Avatar style={{ ...avatarSize, color: "white", backgroundColor: "#bfbfbf", fontSize: "medium" }}>
      {firstName?.[0]?.toUpperCase() ?? "?"}
      {lastName?.[0]?.toUpperCase() ?? "?"}
    </Avatar>
  );
};

export default AvatarInitials;
